import React from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';

const TermsOfServicePage = () => {
    return (
        <div className="min-h-screen bg-black text-white font-sans pt-24 pb-12">
            <SEO
                title="Terms of Service - Qivra Technologies"
                description="Terms of Service for using Qivra Technologies' website and services."
                keywords="terms of service, terms and conditions, legal, qivra technologies terms"
            />
            <div className="max-w-4xl mx-auto px-4 sm:px-6">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-cyan-400 to-purple-600 bg-clip-text text-transparent mb-8">
                        Terms of Service
                    </h1>
                    <p className="text-gray-400 mb-8">Last Updated: January 30, 2026</p>

                    <div className="space-y-8 text-gray-300 leading-relaxed">
                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">1. Acceptance of Terms</h2>
                            <p>
                                By accessing or using the Qivra Technologies website and services, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">2. Jurisdiction and Governing Law</h2>
                            <p>
                                These Terms of Service are governed by and construed in accordance with the laws of India. Any disputes arising out of or in connection with these terms shall be subject to the exclusive jurisdiction of the courts located in New Delhi, India.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">3. Use of Services</h2>
                            <p>
                                You agree to use our website and services only for lawful purposes. You must not:
                            </p>
                            <ul className="list-disc pl-5 space-y-2 mt-2">
                                <li>Violate any applicable laws or regulations.</li>
                                <li>Infringe upon the intellectual property rights of others.</li>
                                <li>Transmit unwanted or spam content.</li>
                                <li>Attempt to gain unauthorized access to our systems.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">4. Intellectual Property</h2>
                            <p>
                                All content, trademarks, logos, and intellectual property displayed on this site are the property of Qivra Technologies or their respective owners. You may not use, reproduce, or distribute any content without our prior written permission.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">5. Limitation of Liability</h2>
                            <p>
                                Qivra Technologies shall not be liable for any direct, indirect, incidental, special, or consequential damages resulting from your use of or inability to use our services, including but not limited to loss of profits, data, or goodwill.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">6. Third-Party Links</h2>
                            <p>
                                Our website may contain links to third-party websites. We are not responsible for the content or privacy practices of such external sites.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">7. Changes to Terms</h2>
                            <p>
                                We reserve the right to modify these Terms of Service at any time. Your continued use of the website after any changes indicates your acceptance of the new terms.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-semibold text-white mb-4">8. Contact Information</h2>
                            <p>
                                For any questions regarding these Terms of Service, please contact us at:
                                <br />
                                <a href="mailto:contact@qivratech.com" className="text-cyan-400 hover:text-cyan-300">contact@qivratech.com</a>
                            </p>
                        </section>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default TermsOfServicePage;
